import styled from 'styled-components';
import { ICON_DEFAULTS } from './Icon';

const IconUser = ({ className, width, height, stroke, fill }) => {
  return (
    <SVG
      className={className}
      width={width || ICON_DEFAULTS.WIDTH}
      height={height || ICON_DEFAULTS.HEIGHT}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="background"
        stroke={stroke}
        d="M15.5 8.00003V8.00069C15.5025 9.93192 14.7574 11.7892 13.4208 13.1831L13.4199 13.184C12.7231 13.9145 11.8856 14.4962 10.9579 14.8943C10.0304 15.2922 9.0319 15.4983 8.0226 15.5C8.02241 15.5 8.02222 15.5 8.02203 15.5H7.97797C7.97778 15.5 7.97759 15.5 7.9774 15.5C6.9681 15.4983 5.96961 15.2922 5.04208 14.8943C4.11437 14.4962 3.27687 13.9145 2.58007 13.184L2.57964 13.1836C1.73209 12.2973 1.11478 11.2168 0.781793 10.0365C0.448805 8.85631 0.410296 7.61244 0.669639 6.41387C0.928983 5.21531 1.47827 4.09862 2.26937 3.16162C3.06048 2.22462 4.06928 1.49591 5.20741 1.0393C6.34553 0.582688 7.57826 0.41212 8.7976 0.542534C10.017 0.672948 11.1857 1.10036 12.2015 1.78734C13.2173 2.47432 14.0492 3.39991 14.6243 4.48302C15.1993 5.56613 15.5 6.77373 15.5 8.00003Z"
      />
      <path
        className="inner-silhouette"
        stroke={stroke}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.8492 12C12.26 11.2844 11.5195 10.7083 10.6811 10.3131C9.84259 9.91788 8.92696 9.71338 8.00002 9.71432C7.07308 9.71338 6.15745 9.91788 5.31899 10.3131C4.48053 10.7083 3.74007 11.2844 3.15088 12C3.74007 12.7156 4.48053 13.2917 5.31899 13.687C6.15745 14.0822 7.07308 14.2867 8.00002 14.2857C8.92696 14.2867 9.84259 14.0822 10.6811 13.687C11.5195 13.2917 12.26 12.7156 12.8492 12ZM8.00002 8.57146C8.75778 8.57146 9.48451 8.27044 10.0203 7.73463C10.5561 7.19881 10.8572 6.47208 10.8572 5.71432C10.8572 4.95656 10.5561 4.22983 10.0203 3.69402C9.48451 3.1582 8.75778 2.85718 8.00002 2.85718C7.24226 2.85718 6.51553 3.1582 5.97972 3.69402C5.4439 4.22983 5.14288 4.95656 5.14288 5.71432C5.14288 6.47208 5.4439 7.19881 5.97972 7.73463C6.51553 8.27044 7.24226 8.57146 8.00002 8.57146Z"
      />
    </SVG>
  );
};

const SVG = styled('svg')({
  fill: 'none',
  stroke: 'currentcolor',
});

export { IconUser };
